var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-textarea',_vm._b({model:{value:(_vm.internal),callback:function ($$v) {_vm.internal=$$v},expression:"internal"}},'b-form-textarea',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }